import { InitAdapter } from '../../types';

export const initAdapter: InitAdapter = ({ deviation, pcp }) => {
  // Note: Pcp data might be present even if pcp is not currently enabled.
  const assets = pcp?.assets ?? [];
  const pcpEnabled = !!deviation?.pcp;
  return pcpEnabled && (assets.length > 0 || (pcp?.includesOriginal ?? false));
};
